<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditDialog="openEditDialog"
      @reject="openReject"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reload="resetPage"
        @openEditDialog="openEditDialog"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>

    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="700px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
      v-el-dialog-drag
    >
      <edit-form
        ref="editForm"
        :disabled="editFormDialogOptions.disabled"
        :colorCode="editFormDialogOptions.code"
        @reload="reload"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          this.$l('INDEX.btn_cancel') || 取消
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="$refs.editForm.save()"
          >{{ this.$l('INDEX.btn_save') || 保存 }}</el-button
        >
      </span>
    </el-dialog>

    <RejectedForm
      :visible.sync="rejectedFormOpts.visible"
      :colorCode="rejectedFormOpts.colorCode"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import BasePage from '@/mixins/base-pagination'
import EditForm from '../edit-form'
import RejectedForm from '../rejected-form'
export default {
  components: { PageHeader, PageMain, EditForm, RejectedForm },
  mixins: [BaseTable, BasePage],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: { visible: false, code: '' },
      rejectedFormOpts: { visible: false, colorCode: '' },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .masterColorListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditDialog({ type, code = '' }) {
      const types = {
        edit: this.$l('table_head_edit_color') || '编辑颜色信息',
        add: this.$l('table_head_add_color') || '增加颜色信息',
        detail: this.$l('table_head_color_detail') || '颜色信息详情',
      }

      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        code: code,
        disabled: type === 'detail',
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
    openReject({ colorCode }) {
      this.rejectedFormOpts = { visible: true, colorCode }
    },
  },
}
</script>
